import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import PageContent from '@/components/ui/PageContent.vue'
import ContentInfo from '@/components/content/ContentInfo.vue'

export default {
  load(Vue) {
    Vue.component('vue-perfect-scrollbar', VuePerfectScrollbar)
    Vue.component('v-page-content', PageContent)
    Vue.component('v-content-info-page', ContentInfo)
  }
}
